import React from 'react';
import { FormRow } from './FormRow';
import { DateTimeRow } from './DateTimeRow';

const defaultDateObject = {
  startTime: null,
  endTime: null,
  startTimeMS: null,
  endTimeMS: null,
};

export function DateFormWidget({
  dates: datesProp,
  label,
  allowMultiple,
  required,
  handleDateChange,
  readOnly = false,
  datesError,
}) {
  let dates = datesProp;
  if (!dates || !dates.length) {
    dates = [defaultDateObject];
  }

  const addDateRow = () => {
    const newDateRow = { ...defaultDateObject };
    handleDateChange([...dates, newDateRow]);
  };

  const deleteDateRow = (index) => {
    const next = [...dates];
    next.splice(index, 1);
    handleDateChange(next);
  };

  const dateChanged = (index, ms) => {
    const next = [...dates];
    next[index] = { ...next[index], startTimeMS: ms != null ? ms : null };
    delete next[index].startTime;
    handleDateChange(next);
  };

  const startTimeChanged = (index, ms) => {
    const next = [...dates];
    delete next[index].startTime;
    next[index] = {
      ...next[index],
      startTimeMS: ms != null ? ms : null,
    };
    handleDateChange(next);
  };

  const endTimeChanged = (index, ms) => {
    const next = [...dates];
    delete next[index].endTime;
    next[index] = {
      ...next[index],
      endTimeMS: ms != null ? ms : null,
    };
    handleDateChange(next);
  };

  return (
    <div data-form-field="dates">
      {dates.map((date, index) => (
        <FormRow
          key={date.startTimeMS || index}
          label={`${index === 0 ? label : ''}`}
          error={index === 0 && datesError ? datesError : undefined}
        >
          <DateTimeRow
            index={index}
            date={date.startTimeMS}
            startTime={date.startTimeMS}
            endTime={date.endTimeMS}
            onRowAdd={addDateRow}
            onRowDelete={deleteDateRow}
            onDateChange={dateChanged}
            onStartTimeChange={startTimeChanged}
            onEndTimeChange={endTimeChanged}
            allowMultiple={allowMultiple}
            readOnly={readOnly}
          />
        </FormRow>
      ))}
    </div>
  );
}
